import React, { useState } from 'react';
import { useTranslate } from 'react-admin';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

import IconButton from '../../common/buttons/IconButton';

const HelpButton = () => {
    const [showDialog, setShowDialog] = useState(false);
    const translate = useTranslate();

    const handleOpen = () => {
        setShowDialog(true);
    };

    const handleClose = () => {
        setShowDialog(false);
    };

    return (
        <>
            <IconButton onClick={handleOpen} icon={<HelpOutlineIcon />}>{translate('Help')}</IconButton>
            <Dialog fullWidth open={showDialog} onClose={handleClose} aria-label="Help leaves">
                <DialogTitle>{translate('Help')}</DialogTitle>
                <DialogContent>
                    <Typography gutterBottom sx={{ fontWeight: 'bold'}}>{translate('Only leaves with type "leave" are counted.')}</Typography>
                    <Typography>{translate('Make two different requests if your leaves overlap two months (this will make the automatic calculations easier).')}</Typography>
                </DialogContent>
            </Dialog>
        </>
    );
};

export default HelpButton;